import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { EyeOutlined } from "@ant-design/icons";
import HttpService from "../services/httpService";
import { connect, useSelector } from "react-redux";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import {
    FormControlLabel,
    RadioGroup,
    FormControl,
    Radio,
    Box,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	DialogContentText,
	TextField,
} from "@material-ui/core";
import { Modal } from "antd";
import PoStdRateDetailsModal from "./PoStdRateDetailsModal";
import SoStdRateDetailsModal from "./SoStdRateDetailsModal";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 850,
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 500,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#3F51B5",
        color: "#FFF",
        fontWeight: "1000",
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const ApproveStdRateOfMaterial = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);
    const [poSoForApproval, setPoSoForApproval] = useState([]);
    const [radioValue, setRadioValue] = useState("PO");
    const [poDetailsModal, setPoDetailsModal] = useState(false);
    const [poDetails, setPoDetails] = useState({});
    const [soDetailsModal, setSoDetailsModal] = useState(false);
    const [soDetails, setSoDetails] = useState({});
    const [openAlertModel, setOpenAlertModel] = useState(false);
	const [remarks, setRemarks] = useState("");
	const [modalInfo, setModalInfo] = useState({
		orderId: "",
		index: "",
		action: "",
		type: "",
	});

    // Function to generate PO's after clicking
    const generateSo = async (soId) => {
        props.setLoading(true);
        try {
            const result = await HttpService.generateSO(soId);
            window.open(result.data.link);
            props.REFRESHDATA();
        } catch (error) {
            console.error(error);
            props.setSnackInfo(
                error?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // Function to generate PO's after clicking
    const generatePo = async (poId) => {
        props.setLoading(true);
        try {
            const result = await HttpService.generatePO(poId);
            window.open(result.data.link);
            props.REFRESHDATA();
        } catch (error) {
            console.error(error);
            props.setSnackInfo(
                error?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // Function to open a detailed modal after clicking on POs
    const openPoDetailsModal = async (procurementId) => {
        props.setLoading(true);
        try {
            props.setLoading(true);
            const response = await HttpService.getProcurementDetails(procurementId);
            setPoDetails(response.data);
            // setPoDetailsModal(true);
        } catch (error) {
            console.error(error);
            props.setLoading(false);
            props.setSnackInfo("Couldn't get raised po details", "error");
        }
        props.setLoading(false);
    };

    // Function to open a detailed modal after clicking on SOs
    const openSoDetailsModal = async (serviceOrderId) => {
        props.setLoading(true);
        try {
            const response = await HttpService.getServiceOrderDetails(serviceOrderId);
            setSoDetails(response.data);
            // setSoDetailsModal(true);
        } catch (error) {
            console.error(error);
            props.setSnackInfo("Couldn't get raised so details", "error");
        }
        props.setLoading(false);
    };

    // Function to handle the radio Change for PO & SO
    const handleRadioChange = (event) => {
        setRadioValue(event.target.value);
        setModalInfo({ orderId: "", index: "", action: "", type: "" });
		setRemarks("");
    };

    // function to get all PO which are approved by operation head and
    //    sent for approval for updating std price of material  along with PO approval
    const getAllProcurementsApprovedByOperationHead = async () => {
        props.setLoading(true);
        try {
            const response =
                await HttpService.getAllProcurementsApprovedByOperationHead();
            setPoSoForApproval(response.data);
        } catch (error) {
            console.error(error);
            props.setSnackInfo("Couldn't get raised po details", "error");
        }
        props.setLoading(false);
    };

    // function to get all SO which are approved by operation head and
    //     sent for approval for updating std price of material along with SO approval
    const getAllServiceOrdersApprovedByOperationHead = async () => {
        props.setLoading(true);
        try {
            const response =
                await HttpService.getServiceOrdersApprovedByOperationHead();
            setPoSoForApproval(response.data);
        } catch (error) {
            console.error(error);
            props.setSnackInfo("Couldn't get raised po details", "error");
        }
        props.setLoading(false);
    };

    // Function to approve procurement or send it for std price updation approval
	const approveProcurementConfirm = async (procurementId, index) => {
		props.setLoading(true);
		try {
			const obj = [];
			let data = {
				materialElementId: poDetails?.materials[index]?._id,
				materialId: poDetails?.materials[index]?.materialId?._id,
				pricePerUnit: poDetails?.materials[index]?.pricePerUnit,
				requestedPrice: poDetails?.materials[index]?.approvedRate,
				requestedQuantity: poDetails?.materials[index]?.approvedQuantity,
				projectId: props?.SELECTEDPROJECT?._id ?? poDetails?.projectId?._id,
				projectMaterialId: poDetails?.materials[index]?.projectMaterialId,
				quantity: poDetails?.materials[index]?.quantity,
				scopeId: poDetails?.materials[index]?.scopeId?._id,
				approveForCurrentPo: poDetails?.materials[index]?.approveForCurrentPo,
				updateStandardRateOfMaterial:
					poDetails?.materials[index]?.updateStandardRateOfMaterial,
				vendorId: poDetails?.vendorId?._id,
				finalApprover: userDetails?._id,
				remark: remarks,
			};
			obj.push(data);
			if (
				poDetails?.materials[index].approveForCurrentPo &&
				poDetails?.materials[index].updateStandardRateOfMaterial &&
				poDetails?.materials[index].operationHeadApproved
			) {
				const result = await HttpService.approveProcurementUpdateStdRate(
					procurementId,
					obj
				);
				if (result.status === 200) {
					props.setSnackInfo("PO Approved & Std Rate Updated", "success");
					// props.REFRESH(procurementId);
					getAllProcurementsApprovedByOperationHead();
				}
			}
			if (
				poDetails?.materials[index].approveForCurrentPo &&
				!poDetails?.materials[index].updateStandardRateOfMaterial
			) {
				const result = await HttpService.approveProcurement(procurementId, obj);
				if (result.status === 200) {
					props.setSnackInfo("PO Approved", "success");
					// props.REFRESH(procurementId);
					getAllProcurementsApprovedByOperationHead();
				}
			}
			setModalInfo({ orderId: "", index: "", action: "", type: "" });
			setOpenAlertModel(false);
			setRemarks("");
		} catch (error) {
			console.error(error);
			props.setSnackInfo(error?.response?.data, "error");
		}
		props.setLoading(false);
	};

	// Function to reject the procurement
	const rejectProcurementConfirm = async (procurementId, index) => {
		props.setLoading(true);
		try {
			if (remarks === "") {
				props.setSnackInfo("Please Enter your remark", "error");
			} else {
				const obj = [];
				let data = {
					materialElementId: poDetails?.materials[index]?._id,
					materialId: poDetails?.materials[index]?.materialId?._id,
					pricePerUnit: poDetails?.materials[index]?.pricePerUnit,
					requestedPrice: poDetails?.materials[index]?.requestedPrice,
					requestedQuantity: poDetails?.materials[index]?.requestedQuantity,
					projectId: props?.SELECTEDPROJECT?._id ?? poDetails?.projectId?._id,
					projectMaterialId: poDetails?.materials[index]?.projectMaterialId,
					quantity: poDetails?.materials[index]?.quantity,
					scopeId: poDetails?.materials[index]?.scopeId?._id,
					remarks: remarks,
				};
				obj.push(data);
				const result = await HttpService.rejectProcurement(procurementId, obj);
				if (result.status === 200) {
					props.setSnackInfo("PO Rejected", "success");
					// props.REFRESH(procurementId);
					getAllProcurementsApprovedByOperationHead();
				}
			}
			setModalInfo({ orderId: "", index: "", action: "", type: "" });
			setOpenAlertModel(false);
			setRemarks("");
		} catch (error) {
			console.error(error);
			props.setSnackInfo(error?.response?.data, "error");
		}
		props.setLoading(false);
	};

	// Approve PO helper function
	const approvePO = (procurementId, index) => {
		props.setLoading(true);
		try {
			setOpenAlertModel(true);
			setModalInfo({
				orderId: procurementId,
				index: index,
				action: "Approval",
				type: "PO",
			});
			openPoDetailsModal(procurementId);
		} catch (error) {
			console.error(error);
			props.setSnackInfo(error?.response?.data, "error");
		}
		props.setLoading(false);
	};

	// Reject PO helper function
	const rejectPO = (procurementId, index) => {
		props.setLoading(true);
		try {
			setOpenAlertModel(true);
			setModalInfo({
				orderId: procurementId,
				index: index,
				action: "Rejection",
				type: "PO",
			});
			openPoDetailsModal(procurementId);
		} catch (error) {
			console.error(error);
			props.setSnackInfo(error?.response?.data, "error");
		}
		props.setLoading(false);
	};

	// Function to update the status of SO's
	const editServiceOrderStatus = async (status) => {
		props.setLoading(true);
		try {
			let data = {
				materialElementId: soDetails?.materials[0]?._id,
				materialId: soDetails?.materials[0]?.materialId?._id,
				requestedPrice: soDetails?.materials[0]?.price,
				pricePerUnit: soDetails?.materials[0]?.vendorPrice,
				requestedQuantity: soDetails?.materials[0]?.requestedQuantity,
				projectId: props?.SELECTEDPROJECT?._id ?? soDetails?.projectId?._id,
				projectMaterialId: soDetails?.materials[0]?.projectMaterialId,
				quantity: soDetails?.materials[0]?.quantity,
				scopeId: soDetails?.scopeId?._id,
				approveForCurrentPo: soDetails?.materials[0]?.approveForCurrentSo,
				updateStandardRateOfMaterial:
					soDetails?.materials[0]?.updateStandardRateOfMaterial,
				operationHeadApproved: soDetails?.materials[0]?.operationHeadApproved,
				status: status,
				vendorId: soDetails?.materials[0]?.vendorId,
				firstApprover: soDetails?.materials[0]?.firstApprover,
				finalApprover: userDetails?._id,
				remarks: {
					date: new Date(),
					action: remarks,
					userId: userDetails._id,
				},
			};

			if (
				soDetails?.materials[0].approveForCurrentSo &&
				soDetails?.materials[0].updateStandardRateOfMaterial &&
				soDetails?.materials[0].operationHeadApproved
			) {
				const result = await HttpService.editServiceOrderStatus(
					soDetails?._id,
					data
				);
				if (result.status === 200) {
					props.setSnackInfo("SO Approved & Std Rate Updated", "success");
					// props.REFRESH(soDetails?.orderId);
					getAllServiceOrdersApprovedByOperationHead();
				}
			}
			if (
				soDetails?.materials[0].approveForCurrentSo &&
				!soDetails?.materials[0].updateStandardRateOfMaterial
			) {
				const result = await HttpService.editServiceOrderStatus(
					soDetails?._id,
					data
				);
				if (result.status === 200) {
					props.setSnackInfo(`Service order ${status}`, "success");
					// props.REFRESH(soDetails?.orderId);
					getAllServiceOrdersApprovedByOperationHead();
				}
			}
			setModalInfo({ orderId: "", index: "", action: "", type: "" });
			setOpenAlertModel(false);
			setRemarks("");
		} catch (error) {
			console.error(error);
			props.setSnackInfo(
				error?.response?.data?.message ?? "Something went wrong",
				"error"
			);
		}
		props.setLoading(false);
	};

	// Function to reject a Service Order
	const rejectSoConfirm = async () => {
		props.setLoading(true);
		try {
			if (remarks === "") {
				props.setSnackInfo("Please Enter your remark", "error");
			} else {
				let obj = {
					status: "Rejected",
					remarks: {
						date: new Date(),
						action: remarks,
						userId: userDetails._id,
					},
				};
				let response = await HttpService.editServiceOrderStatus(
					soDetails?._id,
					obj
				);
				props.setSnackInfo(response?.data ?? "Something went wrong", "success");
				getAllServiceOrdersApprovedByOperationHead();
			}
			setModalInfo({ orderId: "", index: "", action: "", type: "" });
			setOpenAlertModel(false);
			setRemarks("");
		} catch (error) {
			console.error(error);
			props.setSnackInfo(error?.response?.data?.message ?? "Error", "error");
		}
		props.setLoading(false);
	};

	// Approve SO helper function
	const approveSO = (serviceOrderId, index) => {
		props.setLoading(true);
		try {
			setOpenAlertModel(true);
			setModalInfo({
				orderId: serviceOrderId,
				index: index,
				action: "Approval",
				type: "SO",
			});
			openSoDetailsModal(serviceOrderId);
		} catch (error) {
			console.error(error);
			props.setSnackInfo(error?.response?.data, "error");
		}
		props.setLoading(false);
	};

	// Approve SO helper function
	const rejectSo = (serviceOrderId, index) => {
		props.setLoading(true);
		try {
			setOpenAlertModel(true);
			setModalInfo({
				orderId: serviceOrderId,
				index: index,
				action: "Rejection",
				type: "SO",
			});
			openSoDetailsModal(serviceOrderId);
		} catch (error) {
			console.error(error);
			props.setSnackInfo(error?.response?.data, "error");
		}
		props.setLoading(false);
	};

	// Function to close open modal
	const closeOpenModalHandler = () => {
		props.setLoading(true);
		try {
			setRemarks("");
			setOpenAlertModel(false);
		} catch (error) {
			console.error(error);
			props.setSnackInfo(error?.response?.data, "error");
		}
		props.setLoading(false);
	};

    useEffect(() => {
        if (radioValue === "PO") {
            getAllProcurementsApprovedByOperationHead();
        } else if (radioValue === "SO") {
            getAllServiceOrdersApprovedByOperationHead();
        }
    }, [radioValue]);

    return (
        <div>
            <div className={classes.report}>
                <Paper className={classes.paper}>
                    <center>
                        <h2>Standard Rate Approval Requests</h2>
                    </center>
                </Paper>
            </div>
            <div style={{ alignSelf: "center" }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="type"
                        name="type"
                        value={radioValue}
                        onChange={handleRadioChange}
                    >
                        <div className="modal-header-radio">
                            <FormControlLabel value="PO" control={<Radio />} label="PO" />
                            <FormControlLabel value="SO" control={<Radio />} label="SO" />
                        </div>
                    </RadioGroup>
                </FormControl>
            </div>
            <TableContainer component={Paper}>
                <Table
                    className={classes.table}
                    size="small"
                    aria-label="customized table"
                >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Sl No</StyledTableCell>
                            <StyledTableCell>Project No</StyledTableCell>
                            <StyledTableCell>Status</StyledTableCell>
                            <StyledTableCell>Requestor Name</StyledTableCell>
                            <StyledTableCell>Client Name</StyledTableCell>
                            <StyledTableCell>Vendor Name</StyledTableCell>
                            <StyledTableCell>Material Name</StyledTableCell>
                            <StyledTableCell>Requested Rate</StyledTableCell>
                            <StyledTableCell>Approved Rate</StyledTableCell>
                            <StyledTableCell>Vendor Rate</StyledTableCell>
                            <StyledTableCell>Action</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {poSoForApproval?.map((data, i) => (
                            <StyledTableRow key={i + 1}>
                                <StyledTableCell>{i + 1}</StyledTableCell>
                                <StyledTableCell>
									{ data?.projectId?.code || data?.projectCode || "N/A"}
								</StyledTableCell>
                                <StyledTableCell>{data?.status}</StyledTableCell>
                                <StyledTableCell>{data?.createdBy?.name || data?.requesterName}</StyledTableCell>
                                <StyledTableCell>
									{data?.projectId?.clientName || data?.clientName || "N/A"}
								</StyledTableCell>
                                <StyledTableCell>{data?.vendorId?.name || data?.vendorName}</StyledTableCell>
                                <StyledTableCell>{data?.materialName}</StyledTableCell>
                                <StyledTableCell>
                                    {parseFloat(data?.requestedPrice)?.toFixed(2) || 0}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {parseFloat(
                                        data?.approvedRate || data?.requestedPrice
                                    )?.toFixed(2) || 0}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {parseFloat(data?.vendorMaterial?.pricePerUnit)?.toFixed(2) ||
                                        0}
                                </StyledTableCell>
                                <StyledTableCell>
									<div className="approve-reject-btn">
										<button
											onClick={() => {
												if (radioValue === "PO") {
													approvePO(
														poSoForApproval[i]?._id,
														poSoForApproval[i]?.materialIndex
													);
												}
												if (radioValue === "SO") {
													approveSO(poSoForApproval[i]?.orderId, null);
												}
											}}
											className="approve-btn"
										>
											Approve
										</button>
										<button
											onClick={() => {
												if (radioValue === "PO") {
													rejectPO(
														poSoForApproval[i]?._id,
														poSoForApproval[i]?.materialIndex
													);
												}
												if (radioValue === "SO") {
													rejectSo(poSoForApproval[i]?.orderId, null);
												}
											}}
											className="reject-btn"
										>
											Reject
										</button>
									</div>
								</StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Opens modal for std rate approval for po */}
            <Modal
                title="Approve Std Rate"
                centered
                visible={poDetailsModal}
                onCancel={() => setPoDetailsModal(false)}
                width={1000}
                footer={null}
                maskClosable={false}
            >
                <PoStdRateDetailsModal
                    PODETAILS={poDetails}
                    REFRESH={openPoDetailsModal}
                    VIEWALL={() => {
                        setPoDetailsModal(false);
                        getAllProcurementsApprovedByOperationHead();
                    }}
                    TITLE={"Approve Std Rate"}
                />
            </Modal>

            {/* Opens modal for std rate approval for so */}
            <Modal
                title="Approve Std Rate"
                centered
                visible={soDetailsModal}
                onCancel={() => setSoDetailsModal(false)}
                width={1000}
                maskClosable={false}
                footer={null}
            >
                <SoStdRateDetailsModal
                    SODETAILS={soDetails}
                    REFRESH={openSoDetailsModal}
                    VIEWALL={() => {
                        setSoDetailsModal(false);
                        getAllServiceOrdersApprovedByOperationHead();
                    }}
                    TITLE={"Approve SO"}
                />
            </Modal>
            
            {/* Alert Box For Approve and Reject */}
			<div>
				<Dialog
					open={openAlertModel}
					onClose={closeOpenModalHandler}
					aria-labelledby="form-dialog-title"
					maxWidth="sm"
					fullWidth
				>
					<DialogContent>
						<DialogContentText>
							Enter Remarks For {modalInfo.action}
						</DialogContentText>
						<TextField
							id="remarks"
							name="Remarks"
							label="Add Remarks"
							variant="outlined"
							type="text"
							value={remarks}
							onChange={(e) => setRemarks(e.target.value)}
							fullWidth
						/>
					</DialogContent>
					<DialogActions>
						<Button
							variant="outlined"
							onClick={closeOpenModalHandler}
							color="secondary"
						>
							Cancel
						</Button>
						<Button
							onClick={() => {
								if (
									modalInfo.type === "PO" &&
									modalInfo.action === "Rejection"
								) {
									rejectProcurementConfirm(modalInfo.orderId, modalInfo.index);
								}
								if (
									modalInfo.type === "PO" &&
									modalInfo.action === "Approval"
								) {
									approveProcurementConfirm(modalInfo.orderId, modalInfo.index);
								}
								if (
									modalInfo.type === "SO" &&
									modalInfo.action === "Approval"
								) {
									editServiceOrderStatus("Approved");
								}
								if (
									modalInfo.type === "SO" &&
									modalInfo.action === "Rejection"
								) {
									rejectSoConfirm();
								}
							}}
							variant="outlined"
							color="primary"
						>
							Submit
						</Button>
					</DialogActions>
				</Dialog>
			</div>
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(
    ApproveStdRateOfMaterial
);